<script lang="ts" setup>
import type { BonusItem as BonusItemType } from '@/interfaces/IBonusWallet'
import CircularProgress from './CircularProgress.vue'

interface Props {
    item: BonusItemType
    formatCurrency: (amount: number) => string
    localizedTitle: string
}

const { item, formatCurrency, localizedTitle } = defineProps<Props>()
</script>

<template>
    <div class="bonus-item">
        <CircularProgress :percentage="item.progressPercentage" class="circular-progress-wrapper" />
        <div class="bonus-content">
            <div class="bonus-title">
                {{ localizedTitle }}
            </div>
            <div class="bonus-content-box">
                <div class="bonus-progress">
                    <strong>{{ formatCurrency(item.currentTurnover) }}</strong>
                    <span>/</span>
                    <span>{{ formatCurrency(item.targetTurnover) }}</span>
                </div>
                <div class="bonus-redeemable">
                    {{ formatCurrency(item.walletBalance) }}
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/common/variables.scss" as *;

.bonus-item {
    display: flex;
    width: 100%;
    padding: 6px 0;
    border-bottom: 1px solid var(--blue-blue-100-E6F4FF, #e6f4ff);

    &:last-child {
        border-bottom: none;
    }
}

.bonus-content {
    display: flex;
    flex: 1;
    flex-direction: column;
    font-size: 14px;
    gap: 2px;
}

.bonus-title {
    color: $bank-color;
    line-height: 1.5;
}

.bonus-content-box {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
}

.bonus-progress {
    display: flex;
    color: $brandColor-600;
    font-size: 12px;
    gap: 6px;
    white-space: nowrap;
}

.circular-progress-wrapper {
    margin-right: 8px;
}

.bonus-redeemable {
    flex: 1;
    color: $bank-color;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.3;
    text-align: right;
    white-space: nowrap;
}

@media (max-width: $web-width) {
    .bonus-content {
        flex-direction: row;
        justify-content: space-between;
        gap: 8px;
    }

    .bonus-title {
        flex: 1;
    }

    .bonus-content-box {
        width: auto;
        flex-wrap: nowrap;
    }

    .bonus-progress {
        display: none;
    }

    .circular-progress-wrapper {
        display: none;
    }

    .bonus-redeemable {
        flex: 0 0 auto;
        text-align: right;
    }
}
</style>
